module.exports = __webpack_public_path__ + "static/ARB_ILLUSTRATION_2-805b493b6655ed5af393a9221f29047e.jpg";